import styles from "./Card.module.scss";

const Card = ({ image, title, desc }) => {
  return (
    <section className={styles.cardMainSection}>
      <div>
        <img src={image} alt={desc} />
      </div>
      <div className={styles.cardContent}>
        <p>{title}</p>
        <p className="text-center">{desc}</p>
      </div>
    </section>
  );
};

export default Card;